// Carousel.tsx
// TODO: remove cheerio
/* eslint-disable react/no-danger */

import React from 'react'
import Image from 'next/image'
import assetLoader from '@utils/internalImageLoader'
import CarouselArrows from './CarouselArrows'
import styles from './carousel.module.scss'

const cheerio = typeof window === 'undefined' ? global.cheerio : window.cheerio

interface CarouselProps {
  cardsToRender: any
  carouselId: string
}

const getModifiedHtml = tableContent => {
  const $ = cheerio.load(tableContent)
  $('img').attr('loading', 'lazy')
  $('img').attr('decoding', 'async')

  const modifiedHTML = $.html()
  return modifiedHTML
}

const Carousel: React.FC<CarouselProps> = ({ cardsToRender, carouselId }) => (
  <>
    <div className={`${styles.CarouselContainer} ${`carousel-${carouselId}`}`}>
      {cardsToRender.map((item, index) => (
        <div key={`${item}`} id={`carousel-card-${index}`} className={`${styles.card} ${styles[item.cardType]}`}>
          <span dangerouslySetInnerHTML={{ __html: getModifiedHtml(item.cardContent) }} />
          <div className={styles['circle-pattern']}>
            <Image
              src={`${assetLoader()}/images/circle-carousel.svg`}
              alt="Carousel Circle Pattern"
              width={173}
              height={172}
              loading="lazy"
              decoding="async"
            />
          </div>
        </div>
      ))}
    </div>

    <CarouselArrows carouselId={carouselId} />
  </>
)

export default Carousel
